import axios from "src/lib/axios";

/**
 *
 * @param {number} page - page number
 * @param {number} page_size - number of items per page
 * @param {string} user - seller's user._id
 * @param {boolean} isAdmin - flag indicating if view admin's created histories or seller's created histories
 * @param {boolean} isSeller - flag indicating if view seller's created histories
 * @returns
 */
export const getAllGenerateHistory = async ({
  page,
  page_size,
  user = null,
  isAdmin = true,
  isSeller = true,
}) => {
  const { data: response } = await axios.get(`/generate-histories`, {
    params: {
      page: page,
      limit: page_size,
      user: user,
      admin: isAdmin,
      seller: isSeller,
    },
  });
  return response.data;
};

/**
 *
 * @param {ObjectId} page - page number
 * @param {ObjectId} page_size - number of items per page
 * @param {ObjectId} userId - seller's user._id
 * @returns
 */
export const getGenerateHistoryBySeller = async ({ page, page_size }) => {
  const { data: response } = await axios.get(`/generate-histories/my`, {
    params: {
      page: page,
      limit: page_size,
    },
  });
  return response.data;
};
